import { Game } from '../types/Game';

/**
 * ロケールに応じてゲームタイトルの表示フィールドを選ぶ。
 * 翻訳ファイルには入れず、DB が保持する name(原語/英語) と japanese_name(日本語) を切り替える。
 * - ja: 日本語名優先（無ければ原語）
 * - en/その他: 原語(英語)優先（無ければ日本語名）
 */
export const localizeGameTitle = (
  game: Pick<Game, 'name' | 'japanese_name'>,
  lang: string,
): string => {
  if (lang.startsWith('ja')) {
    return game.japanese_name || game.name;
  }
  return game.name || game.japanese_name || '';
};
